module.exports = __webpack_public_path__ + "static/media/graph.54a27cac.svg";